import { useEffect, useMemo } from 'react';
import { useStore } from 'store/store';
import { useUtxFeeCalcFeeForUser } from '../../../../../packages/utx-client/src/react';
import { ErrorCode } from '../enum';

export interface UseGetCalcFeeProp {
  monthlyData: {
    fee: any;
    isLoading: boolean;
    refetch: () => void;
  };
  applicationData: {
    fee: any;
    isLoading: boolean;
    refetch: () => void;
  };
}

export interface UseGetCalcFeeParams {
  enabledFetchAppFee?: boolean;
  enabledFetchMonthlyFee?: boolean;
}

export const useGetCalcFee = (params: UseGetCalcFeeParams): UseGetCalcFeeProp => {
  const store = useStore();
  const { enabledFetchAppFee, enabledFetchMonthlyFee } = params;
  // GET Fee
  const queryMonthlyFee = useUtxFeeCalcFeeForUser(
    {
      intent: 'EXCHANGE_SUB_ACCOUNT_MONTHLY_FEE',
      policy_name: 'general_instruction'
    },
    {
      query: {
        enabled: enabledFetchMonthlyFee !== undefined ? enabledFetchMonthlyFee : true
      },
      axios: {
        headers: {
          Authorization: `Bearer ${store.authToken}`
        }
      }
    }
  );

  const queryApplicationFee = useUtxFeeCalcFeeForUser(
    {
      intent: 'EXCHANGE_SUB_ACCOUNT_APPLICATION',
      policy_name: 'general_instruction'
    },
    {
      query: {
        enabled: enabledFetchAppFee !== undefined ? enabledFetchAppFee : true
      },
      axios: {
        headers: {
          Authorization: `Bearer ${store.authToken}`
        }
      }
    }
  );

  const monthlyFeeData = useMemo(() => {
    const data = queryMonthlyFee.data?.data;
    return data;
  }, [queryMonthlyFee.data?.data]);

  const isLoadingMonthlyFee = useMemo(() => {
    return queryMonthlyFee.isLoading;
  }, [queryMonthlyFee.isLoading]);

  const applicationFeeData = useMemo(() => {
    const data = queryApplicationFee.data?.data;
    return data;
  }, [queryApplicationFee.data?.data]);

  const isLoadingApplicationFee = useMemo(() => {
    return queryApplicationFee.isLoading;
  }, [queryApplicationFee.isLoading]);

  useEffect(() => {
    if (queryApplicationFee.error) {
      var statusCode: number | undefined = queryApplicationFee.error.response?.status;
      if (statusCode !== ErrorCode.EXPIRED_TOKEN_ERROR) {
        queryApplicationFee.refetch();
      }
    }
  }, [queryApplicationFee.error]);

  useEffect(() => {
    if (queryMonthlyFee.error) {
      var statusCode: number | undefined = queryMonthlyFee.error.response?.status;
      if (statusCode !== ErrorCode.EXPIRED_TOKEN_ERROR) {
        refetchMonthlyFee();
      }
    }
  }, [queryMonthlyFee.error]);

  const refetchMonthlyFee = () => {
    queryMonthlyFee.refetch();
  };

  const refetchAppFee = () => {
    queryApplicationFee.refetch();
  };

  return {
    monthlyData: {
      fee: monthlyFeeData,
      isLoading: isLoadingMonthlyFee,
      refetch: refetchMonthlyFee
    },
    applicationData: {
      fee: applicationFeeData,
      isLoading: isLoadingApplicationFee,
      refetch: refetchAppFee
    }
  };
};
